import { render, staticRenderFns } from "./updatedetails.vue?vue&type=template&id=dd48b924&scoped=true"
import script from "./updatedetails.vue?vue&type=script&lang=js"
export * from "./updatedetails.vue?vue&type=script&lang=js"
import style0 from "./updatedetails.vue?vue&type=style&index=0&id=dd48b924&prod&scoped=true&lang=css"
import style1 from "./updatedetails.vue?vue&type=style&index=1&id=dd48b924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd48b924",
  null
  
)

export default component.exports